<template>
  <div>
    <div class="card playlist-item">
      <router-link :to="{ name: 'playlist-detail', params: { slug: playlist.slug, playlistId: playlist.pk }}">
        <figure class="image is-3by1">
          <img :src="playlist.hero_image">
        </figure>
        <div class="overlay">
          <div class="content">
            <h4 class="title is-5 text color-red is-marginless">
              {{ playlist.track_count }} tracks
            </h4>
            <h3 class="title is-3 text color-white">
              {{ playlist.name }}
            </h3>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlaylistHeroItem',

  props: {
    playlist: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/variables";
  .card.playlist-item {
    background-color: $bluegrey2 !important;
  }
  .overlay {
    position: absolute;
    /* z-index: 20; */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    color: white;
    background: linear-gradient(0deg, $bluegrey1 4%, rgba(20, 32, 51, 0) 50%);
    .content {
      position: absolute;
      bottom: 4px;
      left: 20px;
      right: 20px;
      height: auto;
    }
  }
</style>
